"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkOverrides = void 0;
var linkOverrides = {
  MuiLink: {
    defaultProps: {
      underline: 'hover',
      variant: 'bodyLarge'
    },
    styleOverrides: {
      root: function root(_ref) {
        var palette = _ref.theme.palette;
        return {
          // .MuiLink-root
          color: palette.primary.main,
          '&:focused': {
            color: palette.action.focus
          },
          '&:active': {
            color: palette.primary.darker
          },
          '&:visited': {
            color: palette.primary.main
          },
          '&:hover': {
            color: palette.primary.dark
          }
        };
      }
    }
  }
};
exports.linkOverrides = linkOverrides;